import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var PigSVG = function PigSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28 12h-1a10.7 10.7 0 00-3-3.7V3.5a.5.5 0 00-.5-.5c-1.9 0-5.8.3-7.5 2.8a.5.5 0 01-.5.2h-.7a10.9 10.9 0 00-10.2 7 1 1 0 01-.6-1 1 1 0 10-2 0 3 3 0 002.1 2.9 10 10 0 00-.1 1.6 10.5 10.5 0 004 8.2V28a1 1 0 001 1h4a1 1 0 001-1v-.5a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v.5a1 1 0 001 1h4a1 1 0 001-1v-2.6a10 10 0 001.6-1.1 1 1 0 01.6-.3H28a2 2 0 002-2v-8a2 2 0 00-2-2zm-12 1h-3a1 1 0 00-1 .8.9.9 0 000 .2 1 1 0 01-2 0 3 3 0 012.8-3H16a1 1 0 010 2zm6 3a1 1 0 111-1 1 1 0 01-1 1z"
  }));
};
PigSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PigSVG);